import {callAPI} from '../../api/rest/callApi';
import reviewPeriodApi from '../../api/rest/reviewPeriodApi';
import {API_REVIEW_PERIOD} from '../../const/Api';
import {RestApiMethod} from '../../const/dataEnum';
import {setPeriods, setSelectedPeriod} from '../actions/periodAction';

const fetchPeriods = () => async (dispatch) => {
  try {
    const res = await callAPI({method: RestApiMethod.GET, url: API_REVIEW_PERIOD});
    const {data, responseCode} = res.data;

    if (responseCode === 0) {
      const formatPeriod = (periodObj) => {
        const p = periodObj.period.split('H');
        return {
          id: periodObj.id,
          text: p.length > 1 ? `${p[0]} - H${p[1]}` : p[0],
          group: '',
          data: periodObj,
        };
      };
      const formatted = data.map(formatPeriod);
      dispatch(setPeriods(formatted));

      const active = formatted.find((p) => p.data.isActive);
      if (active) dispatch(setSelectedPeriod(active));
      return formatted;
    }
  } catch (err) {}
};

const getAll = () => async (dispatch) => {
  const res = await reviewPeriodApi.getAll();
  if (res) {
    return res.data;
  }
  return null;
};

export const reviewPeriodBusiness = {
  getAll,
  fetchPeriods,
};
